<template>
  <div class='count'>
    <div class="title">
      <span>学校画像</span>
    </div>
    <div class="school">
      <div class="school-item scholl-item-one">
        <div class="item-title">
          <span>各院系职工分布图</span>
        </div>
        <div id="staffBox" class="staffBox">

        </div>
      </div>
      <div class="school-item scholl-item-two">
        <div class="item-title">
          <span>各院系学生分布图</span>
        </div>
        <div class="studentBox" id="studentBox"></div>
      </div>
    </div>
    <div class="title">
      <span>图书借阅</span>
    </div>
    <div class="book">
      <div class="book-item book-item-left">
        <div class="item-title">
          <span>近6个月借阅情况统计</span>
        </div>
        <div id="bookBox" class="bookBox"></div>
      </div>
      <div class="book-item book-item-right">
        <div class="item-title">
          <span>图书借阅关键词排名</span>
        </div>
        <div id="bookrankBox" class="bookrankBox">
          <div class="list" v-for="(item, index) in rankData" :key="index" v-if="index < 8">
            <p class="list-left">{{item.bookname}}</p>
            <div class="preBox">
              <div class="preCon" :style="`width:${item.value}%`"></div>
            </div>
            <p class="list-right">{{item.num}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="title">
      <span>民族生源分布</span>
    </div>
    <div class="student">
      <div class="student-item">
        <div class="item-title">
          <span>民族分布排行</span>
        </div>
        <div id="nationBox" class="nationBox"></div>
      </div>
      <div class="student-item">
        <div class="item-title">
          <span>生源 TOP5</span>
        </div>
        <div id="topBox" class="topBox"></div>
      </div>
      <div class="student-item">
        <div class="item-title">
          <span>生源分布</span>
        </div>
        <mapBox :mapData="mapData"></mapBox>
      </div>
    </div>
  </div>
</template>

<script>
  //vuex
  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  //通信总线
  import Bus from 'common/js/bus.js'

  export default {
    name: "count",
    mixins: [],
    data() {
      return {}
    },
    props: [],
    computed: {},
    watch: {},
    methods: {},
    filters: {},
    components: {},
    activated() {
    },
    mounted() {
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
  .count
    border 1px solid #00f
</style>


// WEBPACK FOOTER //
// src/components/datanalysis/oneTable.vue